import React from "react";
import { BookOpen, ArrowRight } from "lucide-react";

const GUIDES = [
  {
    title: "Aturan 50/30/20",
    body: "Alokasikan 50% penghasilan untuk kebutuhan pokok (housing, food, transport), 30% untuk keinginan (hiburan, hobi), dan 20% untuk menabung & investasi. Cocok untuk memulai.",
  },
  {
    title: "Dana Darurat",
    body: "Sisihkan setara 3–6 bulan pengeluaran di rekening terpisah yang mudah diakses. Ini bantalan pertama sebelum kamu berinvestasi agresif.",
  },
  {
    title: "Lunasi Utang Berbunga Tinggi",
    body: "Kartu kredit dan pinjaman online punya bunga 20%+ per tahun. Selesaikan dulu sebelum menabung di reksa dana atau saham.",
  },
  {
    title: "Investasi Berjenjang",
    body: "Mulai dari reksa dana pasar uang (rendah risiko) → obligasi (medium) → saham/ETF (tinggi). Diversifikasi minimum 3 kelas aset.",
  },
  {
    title: "Automate Semua",
    body: "Set autodebet: 25% ke tabungan, 15% ke investasi, sisanya baru untuk pengeluaran. 'Bayar diri sendiri dulu'.",
  },
  {
    title: "Catat Setiap Transaksi",
    body: "Kebiasaan mencatat lebih penting daripada aplikasi mewah. Konsisten 30 hari akan membuka mata soal kebocoran uang.",
  },
];

export default function Guide() {
  return (
    <div className="animate-fade-up">
      <p className="label-caps">Learn</p>
      <h1 className="font-heading text-3xl md:text-4xl font-medium tracking-tight mt-1">Financial Guide</h1>
      <p className="text-sm text-muted-foreground mt-2 max-w-2xl">Prinsip inti keuangan pribadi. Semua materi dirangkum agar mudah diterapkan oleh pemula.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {GUIDES.map((g, i) => (
          <article key={g.title} className="border border-border bg-card p-5 hover:bg-accent/40 transition-colors group" data-testid={`guide-card-${i}`}>
            <div className="flex items-center gap-3">
              <BookOpen className="h-4 w-4 text-ai" />
              <span className="label-caps">Pelajaran {i + 1}</span>
            </div>
            <h3 className="font-heading text-xl font-medium mt-4">{g.title}</h3>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{g.body}</p>
            <div className="mt-4 flex items-center gap-1 text-xs text-muted-foreground opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
              <span>Praktikkan sekarang</span> <ArrowRight className="h-3 w-3" />
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
